import _routes from './routes';
import SpinListView from './component';

export const routes = _routes;
export default SpinListView;



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/SpinListView/index.js